import { render, staticRenderFns } from "./coupon-statistics.vue?vue&type=template&id=3c705fb4&scoped=true&"
import script from "./coupon-statistics.vue?vue&type=script&lang=js&"
export * from "./coupon-statistics.vue?vue&type=script&lang=js&"
import style0 from "./coupon-statistics.vue?vue&type=style&index=0&id=3c705fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c705fb4",
  null
  
)

export default component.exports